module.exports = __webpack_public_path__ + "img/_ico1.728acd26.svg";